define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/profiles/profileEdit.tmpl");
    var Button = require("ui/button/Button");
    var Dropdown = require("ui/dropdown/Dropdown");
    var InputField = require("ui/input-field/InputField");
    var InlineTextarea = require("ui/inline-textarea/InlineTextarea");
    var PermissionsGridView = require("user-management-views/profiles/PermissionsGridView");
    var PermissionsGridModel = require("user-management-models/PermissionsGridModel");
    var ROLES = require("user-management-assets/data/roles.json");
    var BaseModel = require("models/BaseModel");

    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");

    var DEFAULT_COMPARATOR = function(model){
        return model.id;
    };
    var DEFAULT_ORDERBY = "asc";
    var PAGE_SIZE = 100;

    var ProfileEditView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        ProfileEditView = Marionette.ItemView.extend({
                className: "profile-edit",
                template: template,
                ui: {
                    profileName: ".profile-name-input",
                    profileDescription: ".profile-description",
                    role: ".role-container .input-container",
                    assignedUsers: ".assigned-users-container .label",
                    grid: ".permissions-grid-container .table-main",
                    restoreButton: ".restore-defaults-container .restore-button",
                    cancelButton: ".cancel-button",
                    saveButton: ".save-button"
                },
                uiComponents: {
                    profileName: {
                        type: InputField,
                        options: {
                            el: "view.ui.profileName",
                            permutation: InputField.Permutation.B,
                            maxLength: "view.modelValidators.maxNameLength",
                            placeholder: LE.translator.translate("LEUserManagement.profileEdit.name.placeholder")
                        },
                        events: {
                            change: "_onNameChange"
                        }
                    },
                    profileDescription: {
                        type: InlineTextarea,
                        options: {
                            permutation: InlineTextarea.PERMUTATION.A,
                            container: "view.ui.profileDescription",
                            value: "view.model.getDescription",
                        },
                        events: {
                            change: "_onDescriptionChange"
                        }
                    },
                    role: {
                        type: Dropdown,
                        options: {
                            name: "role",
                            container: "view.ui.role",
                            permutation: Dropdown.PERMUTATION.MEDIUM,
                            items: "view._getRoleItems"
                        },
                        events: {
                            change: "_onRoleChange"
                        }
                    },
                    cancelButton: {
                        type: Button,
                        options: {
                            el: "view.ui.cancelButton",
                            permutation: Button.PERMUTATION.LINK
                        },
                        events: {
                            "click": "_onCancel"
                        }
                    },
                    saveButton: {
                        type: Button,
                        options: {
                            el: "view.ui.saveButton",
                            permutation: Button.PERMUTATION.BTN_PRIMARY
                        },
                        events: {
                            "click": "_onSave"
                        }
                    },
                    restoreDefaultsButton: {
                        type: Button,
                        options: {
                            el: "view.ui.restoreButton",
                            permutation: Button.PERMUTATION.BLUELINK,
                            initState: Button.STATES.ENABLED
                        },
                        events: {
                            click: "_onRestoreDefaultsClick"
                        }
                    }
                },
                modelEvents: {
                    "change": "_onModelChange"
                }
                ,

                //<editor-fold desc="Marionette-Functions">
                /*-----------------------------------------------------------------------------------------------*/
                initialize: function (options) {
                    this._initialize(options);
                },
                onRender: function () {
                    this._onRender();
                },
                //</editor-fold>

                //<editor-fold desc="publicFunctions">
                /*-----------------------------------------------------------------------------------------------*/
                //</editor-fold>


                //<editor-fold desc="privateFunctions">
                /*-----------------------------------------------------------------------------------------------*/
                _initialize: function (options) {
                    this.model = options.model;
                    this.modelValidators = this.model.MODEL_VALIDATORS;
                    this.channel = LEUserManagement.media.channel(LEUserManagement.channels.PROFILE_EDIT);
                },

                _onRender: function () {
                    this._bindEvents();

                    this._updateProfileName();
                    this._updateProfileDescription();
                    this._updateRole();
                    this._updateAssignedUsers();
                    this._createGrid();
                    this._updateSaveButtonState();
                    this._setResetDefaultsTooltip();

                    this._setFocus();
                },
                _createGrid: function () {
                    var permissionsCollection = this.model.getPermissionsCollection();
                    permissionsCollection = SelectableCollectionDecorator.decorate(permissionsCollection);
                    this.permissionsOrganizedCollection = OrganizeCollectionDecorator.decorate(permissionsCollection, {
                        comparator: DEFAULT_COMPARATOR,
                        orderBy: DEFAULT_ORDERBY,
                        pageSize: PAGE_SIZE,
                        lazy: true
                    });


                    this.permissionsGridModel = new PermissionsGridModel();
                    this.permissionsGridView = new PermissionsGridView({
                        el: this.ui.grid,
                        model: this.permissionsGridModel,
                        collection: this.permissionsOrganizedCollection
                    });
                    this._rerenderGrid();
                },

                _bindEvents: function () {
                    this.listenTo(this.channel, "profile:save:error", this._onSaveError);
                    this.listenTo(this.channel, "profile:model:change:permissions", this._rerenderGrid);
                },

                _setFocus: function () {
                    this.uiComponents.profileName.setFocus(true);
                },

                _setResetDefaultsTooltip: function() {
                    this.uiComponents.restoreDefaultsButton.setTooltip(LE.translator.translate("LEUserManagement.profileEdit.restore.default.tooltip"));
                },
                _updateProfileName: function () {
                    this.uiComponents.profileName.setValue(this.model.getName());
                    //if (!this.model.isNew()) {
                    //    this.uiComponents.profileName.setEnabled(false);
                    //}
                },

                _updateProfileDescription: function () {
                    this.uiComponents.profileDescription.setValue(this.model.getDescription());
                },
                _updateRole: function () {
                    this.uiComponents.role.setSelection("" + this.model.getRoleTypeId());
                    if (!this.model.isNew()) {
                        this.uiComponents.role.setEnabled(false);
                    }
                },
                _updateAssignedUsers: function () {
                    var label;
                    var totalNumberOfAssignedUsers = this.model.getNumOfAssingnedUsers();
                    var isAssignedToLPA = this.model.getIsAssignedToLPA();
                    var isNewModel = this.model.isNew();
                    var lpaAssignFeatureIsOn = LE.sessionManager.hasLpaProfilesAssignmentFeature();
                    label = LE.translator.translate("LEUserManagement.profileEdit.no.assignedUsers.label");
                    if (!isNewModel) {
                        if (totalNumberOfAssignedUsers > 0 && isAssignedToLPA && lpaAssignFeatureIsOn) {
                            label = LE.translator.translate({
                                key: "LEUserManagement.profileEdit.assignedUsers.and.lpa.label",
                                args: [{key: totalNumberOfAssignedUsers, isTranslate: false}]
                            });
                        }
                        else if (totalNumberOfAssignedUsers === 0 && isAssignedToLPA && lpaAssignFeatureIsOn) {
                            label = LE.translator.translate("LEUserManagement.profileEdit.assignedLpa.label");
                        }
                        else if (totalNumberOfAssignedUsers > 0 && (!isAssignedToLPA || !lpaAssignFeatureIsOn)) {
                            label = LE.translator.translate({
                                key: "LEUserManagement.profileEdit.assignedUsers.label",
                                args: [{key: totalNumberOfAssignedUsers, isTranslate: false}]
                            });
                        }
                    }

                    this.ui.assignedUsers.text(label);
                },

                _onRestoreDefaultsClick: function () {
                    this.channel.trigger("profile:restore:defaults");
                },

                _rerenderGrid: function () {
                    this.permissionsOrganizedCollection.organize({filterModel:this.permissionsGridModel});
                    this.permissionsGridView.render();
                },

                _updateSaveButtonState: function (options) {
                    options = options || {};
                    var isValid = this.model.validateSaveEnabled();

                    if (!isValid) {
                        this.uiComponents.saveButton.setEnabled(false);
                        this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.profileEdit.saveButton.tooltip.mandatoryFields"));
                    }
                    else {
                        if (this.model.isValueChanged() || options.valueIsChanged) {
                            this.uiComponents.saveButton.setEnabled(true);
                            this.uiComponents.saveButton.setTooltip("");
                        }
                        else {
                            this.uiComponents.saveButton.setEnabled(false);
                            this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.profileEdit.saveButton.tooltip.noChanges"));
                        }
                    }
                },

                /**
                 * The user can see the option of specific role in one of the following cases:
                 * - he can view all roles
                 * - he can edit only agent profile - and this is an agent role
                 * - he can edit only agent manager profile - and this is an agent manager role
                 * - this is an existing profile that already set to a role, so the user should view this role
                 * @returns {DEPENDENCY_TYPE.Collection}
                 * @private
                 */
                _getRoleItems: function () {
                    var rolesArr = [];
                    _.each(ROLES, function (value, key) {
                        if (LEUserManagement.hasAllProfilesViewPrivilege() ||
                            (LEUserManagement.hasAgentProfileEditPrivilege() && key === this.model.ROLES.AGENT) ||
                            (LEUserManagement.hasAgentManagerProfileEditPrivilege() && key === this.model.ROLES.AGENT_MANAGER) ||
                            (!this.model.isNew() && key === this.model.getRoleTypeId().toString())) {

                            var roleObj = {
                                key: key,
                                value: LE.translator.translate(value)
                            };
                            rolesArr.push(roleObj);
                        }

                    }, this);

                    return new Dropdown.Collection(rolesArr);
                },

                _onModelChange: function (options) {
                    this._updateSaveButtonState(options);
                },

                _onNameChange: function (componentId, eventName, value) {
                    this.channel.trigger("profile:change:name", value);
                },

                _onDescriptionChange: function (componentId, eventName, value) {
                    this.channel.trigger("profile:change:description", value);
                },

                _onRoleChange: function (componentId, eventName, obj) {
                    this.channel.trigger("profile:change:role", obj.selectedKey);
                },

                _onCancel: function () {
                    this.channel.trigger("profile:cancel");
                },

                _onSave: function () {
                    this.channel.trigger("profile:save");
                },

                _onSaveSuccess: function () {
                    this._hideErrors();
                }
                ,

                _onSaveError: function (errors) {
                    this._setErrors(errors);
                }
                ,

                _setErrors: function (errors) {
                    this._hideErrors();

                    this.errorsOnPage = errors;

                    if (_.has(errors, this.model.KEYS.NAME)) {
                        this.uiComponents.profileName.setError(true, errors[this.model.KEYS.NAME]);
                    }

                    if (_.has(errors, this.model.KEYS.DESCRIPTION)) {
                        this.uiComponents.profileDescription.setError(true, errors[this.model.KEYS.DESCRIPTION]);
                    }
                },

                _hideErrors: function () {
                    this.errorsOnPage = null;
                    this.uiComponents.profileName.setError(false);
                    this.uiComponents.profileDescription.setError(false);
                }
                //</editor-fold>
            }
        );
    }

    LE.module("LEUserManagement", moduleDefinition);

    return ProfileEditView;

});
